(() => {
  const cta = document.querySelector('[data-thorbes-sticky-cta]');
  const productInfo = document.querySelector('product-info');
  const bundle = document.querySelector('#thorbes-bundle');
  const productForm = productInfo ? productInfo.querySelector('product-form') : null;

  if (!cta || !productInfo) return;

  let ticking = false;

  const updateVisibility = () => {
    const triggerElement = bundle ? productForm || bundle : productInfo;
    const triggerBottom = triggerElement.getBoundingClientRect().bottom;
    const shouldShow = triggerBottom < 120;

    cta.classList.toggle('is-visible', shouldShow);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  };

  updateVisibility();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  cta.addEventListener('click', (event) => {
    const targetId = cta.getAttribute('href');

    if (!targetId || !targetId.startsWith('#')) return;

    const target = document.querySelector(targetId);

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
